import type { IconNode } from '../types';

/**
 * @name pineapple-ring
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8ZWxsaXBzZSBjeD0iMTIiIGN5PSIxMCIgcng9IjEwIiByeT0iOCIgLz4KICA8ZWxsaXBzZSBjeD0iMTIiIGN5PSIxMCIgcng9IjMiIHJ5PSIyIiAvPgogIDxwYXRoIGQ9Im02IDQgMS41IDEuNSIgLz4KICA8cGF0aCBkPSJNMTYuNyAzLjQgMTUuNSA1IiAvPgogIDxwYXRoIGQ9Ik0yIDEwdjRjMCA0LjQgNC41IDggMTAgOHMxMC0zLjYgMTAtOHYtNGgtMyIgLz4KICA8cGF0aCBkPSJtOCAxNS0xIDJ2My45IiAvPgogIDxwYXRoIGQ9Ik0xMiAxNnY2IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/pineapple-ring
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const pineappleRing: IconNode = [
  ['ellipse', { cx: '12', cy: '10', rx: '10', ry: '8', key: 'tu8pg4' }],
  ['ellipse', { cx: '12', cy: '10', rx: '3', ry: '2', key: '1rca78' }],
  ['path', { d: 'm6 4 1.5 1.5', key: '19dpyl' }],
  ['path', { d: 'M16.7 3.4 15.5 5', key: '18sijm' }],
  ['path', { d: 'M2 10v4c0 4.4 4.5 8 10 8s10-3.6 10-8v-4h-3', key: 'rp0p2k' }],
  ['path', { d: 'm8 15-1 2v3.9', key: '1l7pck' }],
  ['path', { d: 'M12 16v6', key: 'c8a4gj' }],
];

export default pineappleRing;
